import { request } from "@/lib/request";
import { SystemConfig } from "@/types/setting";

export async function getSystemConfig() {
  return request<SystemConfig>('/api/setting/system_config', {
    method: 'GET'
  });
}

export async function getSystemScripts() {
  return request<any[]>('/api/setting/system_scripts', {
    method: 'GET'
  });
}

export async function getQrContactInfo() {
  return request<string>('/api/setting/qr_contact_info', {
    method: 'GET'
  });
}
